import { useContext } from 'react';
import storesContext from './storesContext';

const useStores = () => useContext(storesContext);

export default useStores;
